import { Component } from 'react';
import PropTypes from "prop-types";
import { Link, Route, Routes } from "react-router-dom";

// Types.
import AlertRules from "../../../types/Alerts/AlertRules";
import InstanceTarget from "../../../types/instance/InstanceTarget";
import HostTarget from "../../../types/host/HostTarget";

// Helpers.
import ConditionalRender from "../../../helpers/ConditionalRender";

// Third-party packages.
import Helmet from "react-helmet";

// Constants.
import { DATA_INITIALISING, DATA_LOADED, DATA_LOADING } from "../../../component/Constants";

// Views.
import Details from './Detail';
import List from './List';
import HeaderActions from "../../../container/header_actions";
import Breadcrumb from "../../../container/breadcrumb";
import AlertsApis from "../../../api/instance/AlertsApis";

interface IAlertRulesProps {
    toggleMenu: Function,
    applyPeriod: Function,
    instances: InstanceTarget[],
    hosts: HostTarget[],
    isAdmin: boolean
}

interface IAlertRulesState {
    loading: number,
    alertRules: AlertRules[]
}

const initialState = {
    loading: DATA_INITIALISING,
    alertRules: []
}

class Rules extends Component<IAlertRulesProps, IAlertRulesState> {
    static propTypes: {
        toggleMenu: PropTypes.Validator<(...args: any[]) => any>,
        applyPeriod: PropTypes.Validator<(...args: any[]) => any>;
    };

    constructor(props: IAlertRulesProps) {
        super(props);

        this.state = initialState;
    };

    componentDidMount() {
        const { loading } = this.state;

        if (loading === DATA_INITIALISING) {

            this.setState({
                loading: DATA_LOADING
            });

            this.getData();
        }
    }

    async getData() {
        // Get all events for all time.
        const alertRules = await AlertsApis.getAlertRules();

        this.setState({
            loading: DATA_LOADED,
            alertRules
        });
    }


    /* Action Methods */
    refresh = () => {

        this.setState({
            loading: DATA_LOADING
        });

        this.getData();
    }

    render() {
        const { loading, alertRules } = this.state;
        const { instances, hosts } = this.props;

        return (

            <div id="content">
                <Helmet>
                    <title>Alert Rules - Settings - DBmarlin</title>
                    <meta name="description" content="Manage custom alert rules"/>
                </Helmet>

                <div id="top-header-wrapper" className="row row-cols-2">
                    <Breadcrumb heading="Alert Rules">
                        <Link to="/admin">Settings</Link>

                        {/**/}
                        <Routes>
                            <Route path="/admin/alert-rules" element={() => <span>Alert Rules</span>}/>
                        </Routes>

                        <Routes>
                            <Route path="/admin/alert-rules/create"
                                   element={() => <Link to="/admin/alert-rules">Alert Rules</Link>}/>
                            <Route path="/admin/alert-rules/:actionId/:id"
                                   element={() => <Link to="/admin/alert-rules">Alert Rules</Link>}/>
                        </Routes>

                        <Routes>
                            <Route path="/admin/alert-rules/create" element={() => <span>Create</span>}/>
                            <Route path="/admin/alert-rules/:actionId/:id" element={(props: any) =>
                                <span>{props.match.params.actionId.charAt(0).toUpperCase() + props.match.params.actionId.slice(1)}</span>}/>
                        </Routes>
                    </Breadcrumb>
                    <HeaderActions toggleMenu={this.props.toggleMenu} refresh={this.refresh}
                                   applyPeriod={this.props.applyPeriod}/>
                </div>

                <div className="loader">
                    <ConditionalRender if={false}>
                        <div className="bar"/>
                    </ConditionalRender>
                </div>

                <div className="row row-cols-1">
                    <Routes>
                        <Route path="/:actionId" element={<Details loading={loading} alertRules={alertRules}
                                                                 instances={instances}
                                                                hosts={hosts} refresh={this.refresh}/>}/>
                        <Route path="/:actionId/:alertRuleId"
                               element={<Details loading={loading} alertRules={alertRules} instances={instances}
                                                 hosts={hosts} refresh={this.refresh}/>}/>
                        <Route path="/"
                               element={<List isAdmin={this.props.isAdmin} loading={loading} alertRules={alertRules} refresh={this.refresh}/>}/>
                    </Routes>
                </div>
            </div>
        )
    }
}

Rules.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
    applyPeriod: PropTypes.func.isRequired
};

export default Rules;
